export default __webpack_public_path__ + "static/media/captur-gallery-1.6cb6f447.jpg";